export const Q_OPTIONS = [
  "button",
  "number",
  "KPI",
  "LastPeriodIndicatorId",
  "ValueIndicatorId",
  "GroupIndicatorId",
  "AverageIndicatorId",
  "DifferenceIndicatorId",
  "GroupAverageIndicatorId",
];

const Q_NON_COLOR_OPTIONS = ["button", "number", "KPI"];

export const Q_COLOR_OPTIONS = Q_OPTIONS.filter(
  (option) => !Q_NON_COLOR_OPTIONS.includes(option),
);
